import * as React from 'react';
import styled, { withTheme } from 'styled-components';
import { propStyles } from '@kurtosys/ksys-portal-components/build/utils/propStyles';
import { roundNumber } from '@kurtosys/ksys_utils/dist/number';

const BarLabelText = styled<any, any>('text')`
    ${propStyles};
`;

const VerticalBarLabel: React.SFC<any> = ({
    fill = 'gray500',
    value,
    textAnchor = 'end',
    verticalAnchor = 'middle',
    fontSize = 'xs',
    viewBox,
    offset,
    precision,
}) => {
    if (precision) {
        value = roundNumber(value, precision, false);
    }
    const textWidth = `${value}`.length * 6; // approximate text width for label positioning
    const x =
        value >= 0
            ? viewBox.x + viewBox.width + offset + textWidth
            : viewBox.x + viewBox.width - offset;
    const y = viewBox.y + viewBox.height / 1.5;

    return (
        <BarLabelText
            x={x}
            y={y}
            fill={fill}
            fontSize={fontSize}
            textAnchor={textAnchor}
            verticalAnchor={verticalAnchor}
        >
            {value}
        </BarLabelText>
    );
};

export default withTheme(VerticalBarLabel) as any;



// WEBPACK FOOTER //
// ./src/Components/VerticalBarLabel.tsx